import { PropsWithChildren } from 'react';
import { useRoutes } from 'react-router-dom';

import { useCommonLayout } from '@/pc/src/hook/useCommonLayout';
import { GiftDetail } from '@/pc/src/pages/GiftDetail';
import { GlobalErrorBoundary } from '@/shared/features';
import { NotFoundComponent } from '@/shared/ui/Error';

const Routes = () => {
  const element = useRoutes([
    {
      path: '/',
      element: (
        <CommonLayout>
          <GiftDetail />
        </CommonLayout>
      ),
    },
    {
      path: '/:giftId',
      element: (
        <CommonLayout>
          <GiftDetail />
        </CommonLayout>
      ),
    },
    {
      path: '/*',
      element: <NotFoundComponent />,
    },
  ]);

  return element;
};
type CommonLayoutProps = PropsWithChildren<{
  isUsed?: boolean;
  useShareButton?: boolean;
}>;
const CommonLayout = ({ children, isUsed, useShareButton }: CommonLayoutProps) => {
  useCommonLayout({ isUsed, useShareButton });
  return <GlobalErrorBoundary>{children}</GlobalErrorBoundary>;
};

export default Routes;
